(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.draw-card.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.draw-card.js');
"use strict";

const Paper = svs.ui.ReactPaper;
const SkeletonLine = svs.components.lbUi.SkeletonLine;
const DrawCardColumnSkeleton = () => React.createElement("div", null, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__title"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__text"
}));
const WagerSkeletonDrawCard = () => React.createElement(Paper, {
  branding: "sport",
  className: "pg_my_bets_wager_fallback__grid__draw_card"
}, React.createElement(DrawCardColumnSkeleton, null), React.createElement(DrawCardColumnSkeleton, null), React.createElement(DrawCardColumnSkeleton, null), React.createElement("div", null, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__participants"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__participants"
})));
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonDrawCard', WagerSkeletonDrawCard);

 })(window);